import autoText from 'autotext';

import Callbacks from 'lib/callbacks';

export default class AbstractSelect {
    /** @var {jquery} element */

    element = null;
    /** @var {jquery} errorElement */

    errorElement = null;
    /** @var {jquery} formGroup */

    formGroup = null;

    constructor(opts = {}, events = {}) {
        this.opts = opts;
        this.events = new Callbacks(events);
    }

    init(elements = {}) {
        if (!elements.element || !elements.element.length) {
            throw new Error('No element');
        }

        if (!elements.error || !elements.error.length) {
            throw new Error('No error element');
        }

        this.element = elements.element;
        this.errorElement = elements.error;
        this.formGroup = this.element.parents('.form-group');
    }

    set(name, value) {
        this.events.trigger('select', value);
        this.at.data({ name, value });
        this.at.val(name);
    }

    /**
     * Сбросить данные селекта
     */
    drop() {
        this.at.reset();
        this.at.val('');
    }

    _onSelect(at, value = {}) {
        this._onDropSelect();
        this.events.trigger('select', value.id);
    }

    _onOpen() {
        if (!this.at) {
            return;
        }

        this.at.data(null);
    }

    /**
     * Событие когда селект вызывает сброс данных
     */
    _onDropSelect() {
        this.error = false;
        this.events.trigger('drop');
    }

    /**
     * Событие перед загрузкой данных
     */
    _onBeforeLoad() {
        this.events.trigger('beforeload');
    }

    get data() {
        return this.at.data() || {};
    }

    get val() {
        return this.at.val();
    }

    /**
     * Отобразить ошибку блока
     * @param  {String} value Строка с ошибкой (или false)
     */
    set error(value) {
        if (!value) {
            if (!this._error) {
                return;
            }

            this._error = false;
            this.errorElement.addClass('hidden').html('');
            this.formGroup.removeClass('has-error');

            return;
        }

        if (this._error !== value) {
            this._error = value;
            this.errorElement.html(value).removeClass('hidden');
            this.formGroup.addClass('has-error');
        }
    }

    /**
     * Отобразить подсказку
     *
     * @param  {String} message
     */
    static set hintMessage(message = '') {
        throw new autoText.Error(message);
    }
}
